// NO EDITAR A MANO
// const id = "footer.link_apps.descarga_nuestra_app";
const valor = `Download our FREE app`;

export default valor;
